export default __webpack_public_path__ + "static/media/evo_dreamcatcher.95c90019.png";